import { Clinician, ClinicianAvailability, RAddress } from 'patientOnboarding/@types';

import { ActiveFilter } from 'patientOnboarding/store/cliniciansGlobal/slice';

export const attachRankSoonestAvailableToClinicians = (
  clinicians: Clinician[],
  visitTypes: ('video_visit' | 'in_office')[]
): any[] => (
  clinicians.map((clinician : Clinician) => {
    const availabilities = clinician.clinician_availabilities || [];

    const filtered = availabilities.filter((slot: ClinicianAvailability) => {
      const isVideo = slot.virtual_or_video_visit === 1;
      const isInOffice = slot.in_person_visit === 1;

      // If no visit types are selected, filter out all slots
      if (visitTypes.length === 0) {
        return true;
      }
      // Match if *any* of the selected visit types is true
      return (
        (visitTypes.includes('video_visit') && isVideo) ||
        (visitTypes.includes('in_office') && isInOffice)
      );
    });

    const sortedSlots = filtered.sort((a: ClinicianAvailability, b: ClinicianAvailability) =>
      new Date(a.appointment_utc_start_datetime.replace(' ', 'T')).getTime() -
      new Date(b.appointment_utc_start_datetime.replace(' ', 'T')).getTime()
    );

    const earliestDate = sortedSlots[0]?.appointment_utc_start_datetime ?? null;

    return {
      ...clinician,
      earliestDate,
    };
  }).sort((a: Clinician, b: Clinician) => (
    // Sort by earliest date slot
    new Date(a?.earliestDate?.replace(' ', 'T') as string)?.getTime() -
    new Date(b?.earliestDate?.replace(' ', 'T') as string)?.getTime()
  )).map((clinician, index) => (
    // Attach the rank soonest to the first address
    {
      ...clinician,
      addresses: [
        {
          ...clinician.addresses[0],
          rank_soonest_available: index,
        },
        ...clinician.addresses.slice(1)
      ],
    }
  )));

const sortKeys: Record<string, string> = {
  soonest_available: 'rank_soonest_available',
  most_available: 'rank_most_available',
  nearest_location: 'distance_in_miles',
};
export const sortClinicians = (clinicians: Clinician[], activeFilters: ActiveFilter[]) => {
  // Sort by most available by default
  const sortBy = activeFilters?.find((filter) => filter?.name === 'sortType') || {
    name: 'sortType',
    value: 'most_available',
  };
  const modalityFilter = activeFilters?.find((filter) => filter?.name === 'modality')?.value as string[];
  const filteredClinicians = attachRankSoonestAvailableToClinicians(clinicians, modalityFilter as any);

  if (sortBy) {
    const sortKey = sortKeys[sortBy.value as string] as keyof RAddress | keyof Clinician;
    const sortedClinicians = filteredClinicians.sort((a: Clinician, b: Clinician) => {
      if (['rank_most_available', 'rank_soonest_available'].includes(sortKey)) {
        const first = parseInt(a.addresses[0][sortKey as keyof RAddress] as string, 10);
        const second = parseInt(b.addresses[0][sortKey as keyof RAddress] as string, 10);
        return first - second;
      }
      return a[sortKey as keyof Clinician] < b[sortKey as keyof Clinician] ? -1 : 1;
    });
    return sortedClinicians;
  }
  return filteredClinicians;
};
